import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { InputErrorOutputComponent } from './input-error-output/input-error-output.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    InputErrorOutputComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    CommonModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    InputErrorOutputComponent,
  ]
})
export class InputSharedModule {
}
